import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2c96766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "android-seat-top"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "base-tag-box" }
const _hoisted_6 = { class: "tag-title" }
const _hoisted_7 = { class: "ckecked-tag-box" }
const _hoisted_8 = { class: "tag-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopRight = _resolveComponent("TopRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_StarFilled = _resolveComponent("StarFilled")!
  const _component_Star = _resolveComponent("Star")!
  const _component_Ticket = _resolveComponent("Ticket")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: $setup.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.drawer) = $event)),
      size: "auto",
      "with-header": false,
      "before-close": $setup.close_sidebar
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" 安卓端顶部占位 "),
        ($setup.config.android)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_menu, {
          class: "right-sidebar-menu",
          "active-text-color": "#ffd04b",
          "background-color": "#545c64",
          "text-color": "#fff",
          onSelect: $setup.menu_select
        }, {
          default: _withCtx(() => [
            _createCommentVNode("封面"),
            _createElementVNode("img", {
              class: "poster",
              src: $setup.blob,
              alt: "漫画封面"
            }, null, 8 /* PROPS */, _hoisted_3),
            _createCommentVNode("名称"),
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.mangaName), 1 /* TEXT */),
            _createCommentVNode("操作"),
            _createCommentVNode("<el-menu-item index=\"read\"><el-icon><Memo /></el-icon>阅读</el-menu-item>"),
            _createCommentVNode("<el-menu-item index=\"collection\"><el-icon><Collection /></el-icon>收藏</el-menu-item>"),
            _createVNode(_component_el_menu_item, { index: "remove" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_TopRight)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('option.remove')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "delete" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Delete)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('option.delete')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "collect" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    ($setup.isCollect)
                      ? (_openBlock(), _createBlock(_component_StarFilled, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_Star, { key: 1 }))
                  ]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode(" " + _toDisplayString($setup.isCollect ? _ctx.$t('option.removeCollect') : _ctx.$t('option.collect')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_menu_item, { index: "tags" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Ticket)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('option.editTags')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.$t('rightSidebar.editTags'),
      modelValue: $setup.editTagsDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.editTagsDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('rightSidebar.baseTagTitle')), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noCheckedTagList, (tagItem) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              class: "tag base-tag",
              color: tagItem.tagColor,
              key: tagItem.tagId,
              onClick: ($event: any) => ($setup.add_manga_tag(tagItem))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "onClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('rightSidebar.ckeckedTagTitle')), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checkedTagList, (tagItem) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              class: "tag ckecked-tag",
              color: tagItem.tagColor,
              key: tagItem.tagId,
              closable: "",
              onClose: ($event: any) => ($setup.remove_tag(tagItem.mangaTagId))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tagItem.tagName), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "onClose"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "modelValue"])
  ]))
}